import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { TextField } from "@mui/material";
import { formatCardNumber, hasCardNumberReachedMaxLength } from "../formatter/formatter";
import { BACKSPACE_KEY_CODE, DELETE_KEY_CODE, ENTER_KEY_CODE, isNumeric } from "../formatter/utility";
import { getCardTypeByValue } from "../validator/card-types-selector";
import { CardLogoComponent } from "./card-image-component";
import { useState } from "react";
import { useTranslation } from "react-i18next";
export var CardNumberComponent = function (_a) {
    var _b, _c;
    var formik = _a.formik, setCardType = _a.setCardType, _d = _a.name, name = _d === void 0 ? "cardNumber" : _d, _e = _a.label, label = _e === void 0 ? "Card Number" : _e, cardType = _a.cardType;
    var cardNumberField = React.useRef(null);
    var _f = useState(), lastKeyPress = _f[0], setLastKeyPress = _f[1];
    var _g = useTranslation(), t = _g.t, i18n = _g.i18n;
    var handleChangeCardNumber = function (event) {
        var formattedCardNumber = event.target.value || '';
        var cardNumber = formattedCardNumber.replace(/\s/g, '');
        if (cardNumberField.current) {
            var cursorPosition_1;
            var element_1 = cardNumberField.current.children[1].children.namedItem("CardNumberInput");
            if (element_1) {
                cursorPosition_1 = element_1.selectionStart || 0;
            }
            var cardType_1 = getCardTypeByValue(cardNumber);
            setCardType(cardType_1);
            cardNumberField.current.value = formatCardNumber(cardNumber);
            formik.handleChange && formik.handleChange(event);
            // Reposition the cursor to the correct place.
            requestAnimationFrame(function () {
                if (cardNumberField.current) {
                    if (document.activeElement !== cardNumberField.current.children[1].children.namedItem("CardNumberInput"))
                        return;
                    if (cardNumberField.current.value[cursorPosition_1 - 1] === ' ') {
                        if (lastKeyPress === BACKSPACE_KEY_CODE) {
                            cursorPosition_1 = cursorPosition_1 - 1;
                        }
                        if (lastKeyPress !== DELETE_KEY_CODE) {
                            cursorPosition_1 = cursorPosition_1 + 1;
                        }
                    }
                    if (cardNumberField.current.value[cursorPosition_1] === ' ') {
                        if (lastKeyPress === DELETE_KEY_CODE) {
                            cursorPosition_1 = cursorPosition_1 + 1;
                        }
                    }
                    if (element_1) {
                        element_1.setSelectionRange(cursorPosition_1, cursorPosition_1);
                    }
                }
            });
        }
    };
    var handleKeyDownCardNumber = function (event) {
        var _a;
        var formattedCardNumber = ((_a = cardNumberField.current) === null || _a === void 0 ? void 0 : _a.value) || '';
        var cardNumber = formattedCardNumber.replace(/\s/g, '');
        var spec = false;
        if ((event.ctrlKey && (event.keyCode == 67 || event.keyCode == 65 || event.keyCode == 86 || event.keyCode == 88)) || event.keyCode == 46) {
            spec = true;
        }
        setLastKeyPress(event.code);
        if (event.key !== ENTER_KEY_CODE && event.key !== BACKSPACE_KEY_CODE && !spec) {
            if (!isNumeric(event)) {
                event.preventDefault();
            }
            if (hasCardNumberReachedMaxLength(cardNumber)) {
                event.preventDefault();
            }
        }
    };
    return (_jsx(TextField, { InputLabelProps: { shrink: true }, id: "CardNumberInput", ref: cardNumberField, label: t("".concat(label)), name: name, size: "small", fullWidth: true, value: (_c = (_b = cardNumberField.current) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '', 
        // value={formik.values[name] ?? ''}
        onChange: function (e) {
            handleChangeCardNumber(e);
        }, onKeyDown: function (e) {
            handleKeyDownCardNumber(e);
        }, required: true, error: formik.touched[name] && Boolean(formik.errors[name]), helperText: t(formik.touched[name] && formik.errors[name]), type: "text", InputProps: {
            endAdornment: _jsx(CardLogoComponent, { cardType: cardType })
        } }));
};
